export default __webpack_public_path__ + "static/media/eva.a6e74505.svg";